export default __webpack_public_path__ + "play-button.faa3b4.svg";